/* Magic Mirror · Home — Play v1.1 (WowStore) — plain JS, no framework. New file; the v1 script asset is untouched.
   Contracts: the v1 build contract of 20 Sep 2026 + the Play v1.1 contract of 21 Sep 2026 (docs/plans).
   v1.1 adds three features, each behind its own server flag (features.taste / .lead / .request, all false at ship).
   With the flags off this is v1 with the new name.
   Fix round 22 Sep 2026: the tester needs a key (?dc_test=1&v11=<key>; the SERVER decides whether it is the right one, this
   file knows no key); the game arm waits behind a neutral skeleton until the flags are known (at most 1.5 s), so a first-time
   visitor never sees the game flash before the taste screen; honest wording when the confirmation mail could not leave;
   request promise = a personal answer within 24 to 72 hours.
   Internal names (dc- ids, dc_ storage keys, the API path) did not change.
   The check is deterministic: numbers come from product data and from colour measured once at build time, never from an LLM.
   All copy lives in STR so Dutch can follow. */
(function (root) {
  'use strict';

  var STR = {
    h1Game: 'Magic Mirror · Home',
    h1List: 'Shop this corner',
    introGame: 'Play: one corner, one brief, three real pieces. Place them, then check your corner. Checking is free and unlimited.',
    introList: 'The pieces picked for this week’s sample corner, with price and delivery time for each.',
    todayBrief: 'Today’s brief',
    cap: 'Cap {cap}',
    req: { no_drill: 'No drilling', light_usb: 'Light on USB', no_flame: 'Nothing that burns', fast_light: 'Light in the 2–7 day lane', plug_eu: 'Mains light with an EU plug' },
    pal: { calm: 'Calm palette', warm: 'Warm palette', one_accent: 'One bold piece' },
    stageLabel: 'Sample room — AI-made backdrop. The pieces are real photos.',
    scaleLabel: 'Not to scale: small pieces are shown larger than life, some about three times, so you can see them. Each card gives the size where the listing states one.',
    slotEmpty: 'Choose: {slot}',
    slotFilled: '{slot}: {name}. Tap to change.',
    trayFor: 'Pieces for: {slot}',
    sizeNotStated: 'size not stated in the listing text',
    sizeInPhoto: 'size not stated in the listing text; the listing photos show measurements',
    sizePrefix: 'Size: ',
    factUsb: 'runs on USB', factMains: 'mains lamp', factPlugUnknown: 'plug type not stated in the listing', factFixingUnknown: 'fixing not stated in the listing',
    total: 'Total {total} · cap {cap}',
    totalEmpty: 'Nothing placed yet · cap {cap}',
    checkBtn: 'Check my corner',
    checkHint: 'Place one piece in each of the three spots first.',
    resultTitle: '{n} of 3 stars',
    starOn: 'Star earned', starOff: 'No star',
    again: 'Swap a piece and check again as often as you like.',
    rowBudget: 'Budget', rowBrief: 'Brief', rowPalette: 'Palette',
    budgetOk: '{total} of {cap} — {left} to spare.',
    budgetExact: '{total} — exactly on the cap.',
    budgetOver: '{total} is {over} over the {cap} cap.',
    budgetCurrency: 'The brief is set in euros and your prices show in {cur}, so we cannot check the budget fairly. No star.',
    budgetUnknown: 'A price is missing, so the budget cannot be checked. No star.',
    otherCurrency: 'another currency',
    noDrillOk: 'No drilling: going by their product type, all three are loose pieces that stand or lie on their own.',
    noDrillFail: 'The {name} has to be fixed to a wall or ceiling.',
    noDrillUnknown: 'The listing of the {name} does not say how it is fixed, so this cannot earn the star.',
    usbOk: 'The {name} runs on USB.',
    usbFail: 'The {name} needs a mains socket.',
    usbOther: 'The {name} does not run on USB.',
    usbUnknown: 'The listing of the {name} does not state how it is powered, so this cannot earn the star.',
    flameOk: 'Nothing here burns.',
    flameFail: 'The {name} holds something that burns.',
    flameUnknown: 'The listing of the {name} does not say whether it burns, so this cannot earn the star.',
    fastOk: 'The {name} is in the 2–7 business day lane (usual time, not a promised date).',
    fastFail: 'The {name} usually takes {days} business days.',
    fastUnknown: 'No delivery lane is stated for the {name}, so this cannot earn the star.',
    plugOk: 'The {name} has an EU plug.',
    plugFail: 'The {name} does not come with an EU plug.',
    plugUnknown: 'The listing of the {name} does not state its plug type, so this cannot earn the star.',
    paletteUnknown: 'The colour of the {name} was not measured, so this cannot earn the star.',
    calmOkMixed: '{warm} warm like the oak, {neutral} neutral — nothing pulls against the room.',
    calmOkWarm: 'All three read warm, like the oak and the linen.',
    calmOkCool: '{cool} cool, {neutral} neutral — one temperature, so it stays calm.',
    calmOkAllCool: 'All three read cool \u2014 one temperature, so it stays calm.',
    calmOkNeutral: 'All three are neutral; the oak does the warming.',
    calmFail: 'The {cool} reads cool and the {warm} reads warm. In a small corner they pull apart — swap one for a neutral piece.',
    warmOk: '{warm} warm; nothing cool pulls against it.',
    warmFailCool: 'The {cool} reads cool, which works against a warm corner.',
    warmFailNone: 'All three are neutral — nothing here is warm yet.',
    accentOk: 'The {name} carries the colour; the other two stay quiet.',
    accentNone: 'No piece carries real colour yet — everything is quiet.',
    accentMany: 'The {a} and the {b} both want the attention. Keep one.',
    reads: '{list} read', readsOne: 'The {list} reads', stay: 'the {list} stay', stayOne: 'the {list} stays',
    seeBtn: 'See the pieces',
    tryBtn: 'Try one piece in my corner',
    shareBtn: 'Share my corner',
    seeTitle: 'The three pieces',
    listSlotTitle: { light: 'Light', surface: 'Surface', soft: 'Soft or wall' },
    view: 'View product',
    add: 'Add to cart',
    adding: 'Adding…',
    inCart: 'In your cart — remove',
    removing: 'Removing…',
    viewCart: 'View cart',
    cartErr: 'That did not work. Please try again, or open the product page.',
    waitTitle: 'Try one piece in my corner',
    waitText: 'Magic Mirror · Home for your own room is being built: one real piece, shown in a photo of your own corner. It is not open yet. Leave your e-mail and we will write once when it opens.',
    waitEmail: 'E-mail address',
    waitConsent: 'Yes, e-mail me once when Magic Mirror · Home opens for my own photo. My address is used for that one message only, not for marketing.',
    waitSubmit: 'Tell me once',
    waitSending: 'Sending…',
    waitDone: 'Thank you. We will write once, when it opens, to {email}.',
    waitErrEmail: 'Please enter a valid e-mail address.',
    waitErrConsent: 'Please tick the box so we may write to you.',
    waitErr: 'That did not work. Please try again in a moment.',
    privacy: 'Privacy policy',
    shareTitle: 'Your corner as a picture',
    shareSave: 'Save image',
    shareNative: 'Share',
    shareCopy: 'Copy link',
    shareCopied: 'Link copied',
    shareText: 'My Magic Mirror · Home corner: {brief} — {n} of 3 stars.',
    shareFoot: 'Sample room, AI-made backdrop. The pieces are real photos, not to scale.',
    shareErr: 'The picture could not be made on this device. You can still copy the link.',
    storageAsk: 'This device keeps one random ID so that we count each visitor once and can see return visits. No name, no tracking across sites.',
    storageYes: 'OK', storageNo: 'Do not keep it',
    resting: 'Magic Mirror · Home is resting today. The shop is open as always.',
    toShop: 'Go to the shop',
    fewPieces: 'Too few pieces are on sale for today’s corner. The shop is open as always.',
    delivery: 'Delivery',
    brand: 'Magic Mirror · Home',
    shareUrlText: 'wowstore.live/pages/magic-mirror-home',
    shareFile: 'magic-mirror-home.png',
    /* ---- v1.1 · taste start (a label for the corners tapped, never a claim about the person) ---- */
    tasteTitle: 'Tap 3 corners you love',
    tasteIntro: 'Eight sample corners. Tap any three, or skip.',
    tasteCount: '{n} of 3 tapped',
    tasteSkip: 'Skip',
    tasteLabel: 'Sample rooms — AI-made backdrops. The pieces are real photos, not to scale.',
    tasteResultEyebrow: 'Your corners today',
    tasteNames: { calm: 'Calm Corner', glow: 'Warm Glow', clear: 'Clear & Light', bold: 'Bold Touch' },
    tasteLines: {
      calm: 'Quiet neutrals with one warm piece beside them.',
      glow: 'Quiet neutrals, and the warmth comes from the lamp.',
      clear: 'Quiet neutrals with one cool piece.',
      bold: 'One piece with strong colour; the rest stays quiet.'
    },
    tasteNote: 'A label for the three corners you tapped, nothing more.',
    tastePlay: 'Play today’s brief',
    tasteShare: 'Taste: {name}',
    /* ---- v1.1 · lead at the reward ---- */
    leadBtn: 'Want this corner in your own room?',
    leadTitle: 'Want this corner in your own room?',
    leadText: 'Leave your e-mail — you get 3 extra free previews when Magic Mirror · Home opens for your own photo.',
    leadConsent: 'Yes, e-mail me once when Magic Mirror · Home opens for my own photo, with my 3 extra free previews. My address is used for that one note only, not for marketing.',
    leadSubmit: 'Keep my 3 previews',
    leadDone: 'One more step: look for our e-mail at {email} and tap the link in it to confirm. Then your 3 extra free previews are kept for you. An address that is not confirmed is deleted after 14 days.',
    leadLater: 'We have your address, but our mail is slow right now. The confirmation link comes to {email} as soon as it works again; that can take until tomorrow. An address that is not confirmed is deleted after 14 days.',
    confirmOk: 'Your e-mail is confirmed. {n} extra free previews are waiting for you when Magic Mirror · Home opens for your own photo. We will write once.',
    confirmBad: 'This confirmation link is not valid any more. You can leave your e-mail again after a check.',
    confirmErr: 'We could not confirm right now. Please open the link from the e-mail again in a moment.',
    /* ---- v1.1 · request lane ---- */
    reqBtn: 'Can’t find it? Ask for it',
    reqTitle: 'Can’t find it? Ask for it',
    reqText: 'Tell us what you are looking for. You get a personal answer within 24 to 72 hours: a piece we sell now, or honestly that we do not have it yet and whether we can look for it.',
    reqWhat: 'What are you looking for?',
    reqLeft: '{n} characters left',
    reqLink: 'A link that shows it (optional)',
    reqLinkHint: 'Pinterest or any web address. We read it; this page does not open it.',
    reqConsent: 'Yes, use my e-mail address to answer this request. It is used for this request only, not for marketing.',
    reqSubmit: 'Send my request',
    reqDone: 'We have your request. You get a personal answer within 24 to 72 hours, at {email}.',
    reqFull: 'We have as many requests as we can answer well for today. Please come back tomorrow.',
    reqErrText: 'Please write a few words about what you are looking for (up to 300 characters).',
    reqErrLink: 'That link does not look like a web address. It should start with https://, or leave the field empty.',
    formErr: 'That did not work. Please try again in a moment.'
  };

  /* ---------- deterministic check (pure; also run in node by the build to count winning corners) ---------- */
  function fmt(s, o) { return s.replace(/\{(\w+)\}/g, function (_, k) { return o[k] == null ? '' : o[k]; }); }
  function joinNames(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
  function reads(a) { return fmt(a.length > 1 ? STR.reads : STR.readsOne, { list: joinNames(a) }); }
  function stays(a) { return fmt(a.length > 1 ? STR.stay : STR.stayOne, { list: joinNames(a) }); }
  function cap1(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  function money(cents, moneyFormat) {
    var f = moneyFormat || '€{{amount}}';
    var v = (cents / 100).toFixed(2);
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return v.replace('.', ',');
      if (k === 'amount_no_decimals') return String(Math.round(cents / 100));
      if (k === 'amount_no_decimals_with_comma_separator') return String(Math.round(cents / 100));
      return v;
    }).replace(/<[^>]+>/g, '');
  }

  function checkRequirement(req, picks) {
    var all = [picks.light, picks.surface, picks.soft], i, p;
    if (req === 'no_drill') {
      for (i = 0; i < 3; i++) { p = all[i]; if (p.fixing === 'fixed') return { ok: false, text: fmt(STR.noDrillFail, { name: p.short }) }; }
      for (i = 0; i < 3; i++) { p = all[i]; if (p.fixing !== 'none') return { ok: false, unknown: true, text: fmt(STR.noDrillUnknown, { name: p.short }) }; }
      return { ok: true, text: STR.noDrillOk };
    }
    if (req === 'light_usb') {
      p = picks.light;
      if (p.power === 'usb') return { ok: true, text: fmt(STR.usbOk, { name: p.short }) };
      if (p.power) return { ok: false, text: fmt(p.power === 'mains' ? STR.usbFail : STR.usbOther, { name: p.short }) };
      return { ok: false, unknown: true, text: fmt(STR.usbUnknown, { name: p.short }) };
    }
    if (req === 'no_flame') {
      for (i = 0; i < 3; i++) { p = all[i]; if (p.flame === true) return { ok: false, text: fmt(STR.flameFail, { name: p.short }) }; }
      for (i = 0; i < 3; i++) { p = all[i]; if (p.flame !== false) return { ok: false, unknown: true, text: fmt(STR.flameUnknown, { name: p.short }) }; }
      return { ok: true, text: STR.flameOk };
    }
    if (req === 'fast_light') {
      p = picks.light;
      if (p.days === '2-7') return { ok: true, text: fmt(STR.fastOk, { name: p.short }) };
      if (p.days) return { ok: false, text: fmt(STR.fastFail, { name: p.short, days: p.days.replace('-', '–') }) };
      return { ok: false, unknown: true, text: fmt(STR.fastUnknown, { name: p.short }) };
    }
    if (req === 'plug_eu') {   /* guard: a mains piece whose plug is not stated can never satisfy a plug requirement */
      p = picks.light;
      if (p.power === 'mains' && p.plug === 'eu') return { ok: true, text: fmt(STR.plugOk, { name: p.short }) };
      if (p.power === 'mains' && p.plug) return { ok: false, text: fmt(STR.plugFail, { name: p.short }) };
      return { ok: false, unknown: true, text: fmt(STR.plugUnknown, { name: p.short }) };
    }
    return { ok: false, unknown: true, text: '' };
  }

  function checkPalette(rule, picks) {
    var all = [picks.light, picks.surface, picks.soft];
    var warm = [], cool = [], neutral = [], vivid = [], i;
    for (i = 0; i < 3; i++) { if (['warm', 'cool', 'neutral'].indexOf(all[i].temp) < 0) return { ok: false, unknown: true, text: fmt(STR.paletteUnknown, { name: all[i].short }) }; }
    all.forEach(function (p) {
      (p.temp === 'warm' ? warm : p.temp === 'cool' ? cool : neutral).push(p.short);
      if (p.vivid) vivid.push(p.short);
    });
    if (rule === 'one_accent') {
      if (vivid.length === 1) return { ok: true, text: fmt(STR.accentOk, { name: vivid[0] }) };
      if (!vivid.length) return { ok: false, text: STR.accentNone };
      return { ok: false, text: fmt(STR.accentMany, { a: vivid[0], b: vivid[1] }) };
    }
    if (rule === 'warm') {
      if (cool.length) return { ok: false, text: fmt(STR.warmFailCool, { cool: cool[0] }) };
      if (!warm.length) return { ok: false, text: STR.warmFailNone };
      return { ok: true, text: fmt(STR.warmOk, { warm: reads(warm) }) };
    }
    /* calm: one temperature plus neutrals */
    if (warm.length && cool.length) return { ok: false, text: fmt(STR.calmFail, { cool: cool[0], warm: warm[0] }) };
    if (warm.length === 3) return { ok: true, text: STR.calmOkWarm };
    if (warm.length) return { ok: true, text: fmt(STR.calmOkMixed, { warm: reads(warm), neutral: stays(neutral) }) };
    if (cool.length === 3) return { ok: true, text: STR.calmOkAllCool };
    if (cool.length) return { ok: true, text: fmt(STR.calmOkCool, { cool: reads(cool), neutral: stays(neutral) }) };
    return { ok: true, text: STR.calmOkNeutral };
  }

  /* picks = {light, surface, soft}; each piece needs: short, price (cents), fixing, power, flame, days, temp, vivid */
  function scoreCorner(brief, picks, currency, moneyFormat) {
    var total = picks.light.price + picks.surface.price + picks.soft.price;
    var capTxt = money(brief.budget_cents, moneyFormat), totTxt = money(total, moneyFormat);
    var budget;
    if (!isFinite(total)) { budget = { ok: false, text: STR.budgetUnknown }; totTxt = ''; }
    else if (currency !== 'EUR') budget = { ok: false, text: fmt(STR.budgetCurrency, { cur: currency || STR.otherCurrency }) };
    else if (total < brief.budget_cents) budget = { ok: true, text: fmt(STR.budgetOk, { total: totTxt, cap: capTxt, left: money(brief.budget_cents - total, moneyFormat) }) };
    else if (total === brief.budget_cents) budget = { ok: true, text: fmt(STR.budgetExact, { total: totTxt }) };
    else budget = { ok: false, text: fmt(STR.budgetOver, { total: totTxt, over: money(total - brief.budget_cents, moneyFormat), cap: capTxt }) };
    var parts = brief.requirements.map(function (r) { return checkRequirement(r, picks); });
    var reqOk = parts.every(function (x) { return x.ok; });
    var failing = parts.filter(function (x) { return !x.ok; });
    var req = { ok: reqOk, text: (reqOk ? parts : failing).map(function (x) { return x.text; }).join(' ') };
    var pal = checkPalette(brief.palette, picks);
    pal.text = cap1(pal.text);
    return { total: total, stars: (budget.ok ? 1 : 0) + (req.ok ? 1 : 0) + (pal.ok ? 1 : 0), budget: budget, brief: req, palette: pal };
  }

  function briefIndex(weekStart, isoDay, n) {
    var a = Date.UTC(+weekStart.slice(0, 4), +weekStart.slice(5, 7) - 1, +weekStart.slice(8, 10));
    var b = Date.UTC(+isoDay.slice(0, 4), +isoDay.slice(5, 7) - 1, +isoDay.slice(8, 10));
    var d = Math.round((b - a) / 86400000) % n;
    return d < 0 ? d + n : d;
  }

  /* v1.1 taste rule — fixed and documented, no model, no claim about the person. Every tile has ONE kind (calm / glow / clear /
     bold), computed at build time from the measured colours of its three pieces (build/v11_config.py).
     Result = the kind tapped at least twice; when the three taps are three different kinds, the kind of the FIRST tile tapped.
     First tray = the emphasis slot tapped at least twice; otherwise the emphasis of the first tile tapped. */
  function tasteResult(tiles) {
    var kinds = {}, slots = {}, i, k, kind = null, slot = null;
    for (i = 0; i < tiles.length; i++) { kinds[tiles[i].kind] = (kinds[tiles[i].kind] || 0) + 1; slots[tiles[i].emphasis] = (slots[tiles[i].emphasis] || 0) + 1; }
    for (k in kinds) { if (kinds[k] >= 2) kind = k; }
    for (k in slots) { if (slots[k] >= 2) slot = k; }
    return { kind: kind || tiles[0].kind, slot: slot || tiles[0].emphasis };
  }

  if (typeof module !== 'undefined' && module.exports) { module.exports = { scoreCorner: scoreCorner, briefIndex: briefIndex, money: money, STR: STR, tasteResult: tasteResult }; }
  if (typeof document === 'undefined') return;

  /* ------------------------------------------ page ------------------------------------------ */
  var dataEl = document.getElementById('dc-data');
  if (!dataEl) return;
  var DC;
  try { DC = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var $ = function (id) { return document.getElementById(id); };
  var qs = new URLSearchParams(location.search);
  var SLOT_ORDER = ['light', 'surface', 'soft'];
  var state = { taste: null, tasteTiles: [], firstSlot: null, arm: null, forced: false, test: qs.get('dc_test') === '1', vid: null, persistent: false, brief: null, picks: {}, slot: 'light', interacted: false, checks: 0, last: null, inCart: {} };

  /* v1.1 flags: all three are false for real visitors until the server says otherwise (GET /today -> features).
     Tester (fix 22 Sep, review M2): ?dc_test=1&v11=<key>. This page knows no key: it hands the value to the server (POST /tester,
     and with every write) and the server compares it with a file only it can read. A wrong value = an ordinary test visit. */
  var V11KEY = state.test && /^[A-Za-z0-9_-]{16,128}$/.test(qs.get('v11') || '') ? qs.get('v11') : null;
  var V11 = false;
  var FEAT = { taste: false, lead: false, request: false };

  function el(tag, attrs, kids) {
    var n = document.createElement(tag), k;
    for (k in attrs || {}) { if (attrs[k] == null || attrs[k] === false) continue; if (k === 'text') n.textContent = attrs[k]; else if (k === 'cls') n.className = attrs[k]; else n.setAttribute(k, attrs[k] === true ? '' : attrs[k]); }
    (kids || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { } return null; }
  function rid() { var a = new Uint8Array(12); (window.crypto || window.msCrypto).getRandomValues(a); return Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join(''); }
  function amsToday() { try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); } catch (e) { return new Date().toISOString().slice(0, 10); } }
  function m(c) { return money(c, DC.money_format); }

  /* ---- pieces: static facts from the build + live storefront data from Liquid ---- */
  var pieces = DC.pieces.filter(function (p) { return p.live && p.live.available && !p.live.preorder; }).map(function (p) {
    var o = {}; for (var k in p) o[k] = p[k];
    o.price = p.live.price; o.days = p.live.days; o.temp = p.colour.temp; o.vivid = p.colour.vivid;
    return o;
  });
  function bySlot(s) { return pieces.filter(function (p) { return p.slot === s; }); }
  function sizeText(p, long) { return p.size ? (long ? STR.sizePrefix + p.size : p.size) : (long && p.size_in_photo ? STR.sizeInPhoto : STR.sizeNotStated); }
  /* power / plug / fixing: only what the listing states; a missing fact is shown as not stated (contract §4.2) */
  function factsText(p) {
    var f = [];
    if (p.power === 'usb') f.push(STR.factUsb);
    if (p.power === 'mains') { f.push(STR.factMains); if (!p.plug) f.push(STR.factPlugUnknown); }
    if (p.fixing == null) f.push(STR.factFixingUnknown);
    return f.join(' · ');
  }

  /* ---- consent + ids ---- */
  function shopifyAnalyticsConsent() {
    var mch = document.cookie.match(/(?:^|; )_tracking_consent=([^;]+)/);
    if (!mch) return null;
    try { var j = JSON.parse(decodeURIComponent(mch[1])); var a = j && j.con && j.con.CMP && j.con.CMP.a; return a === '1' ? true : a === '0' ? false : null; } catch (e) { return null; }
  }
  /* Visitor id (fix 21 Sep, review M2): one random id in first-party storage, so a returning load is the same visitor.
     Not kept when the shop's consent cookie denies analytics or the visitor says so here; then, and when storage does not
     work, the id lives for one load and every row carries persistent=false so the report can leave it out. */
  function forgetIdentity() { ls('dc_vid', null); ls('dc_first', null); ls('dc_last', null); ls('dc_taste', null); state.persistent = false; }
  function setupIdentity() {
    var shopC = shopifyAnalyticsConsent(), own = ls('dc_consent');
    var denied = shopC === false || own === 'no';
    if (denied) forgetIdentity();
    else { state.vid = ls('dc_vid'); if (!state.vid) { state.vid = rid(); ls('dc_vid', state.vid); } state.persistent = ls('dc_vid') === state.vid; }
    if (!state.vid) { state.vid = rid(); state.persistent = false; }
    if (state.persistent && shopC === null && own !== 'yes') showStorageAsk();
  }
  function showStorageAsk() {
    var box = $('dc-storage'); if (!box) return;
    var yes = el('button', { type: 'button', cls: 'dc-link-btn', text: STR.storageYes }), no = el('button', { type: 'button', cls: 'dc-link-btn', text: STR.storageNo });
    box.appendChild(el('span', { text: STR.storageAsk + ' ' })); box.appendChild(yes); box.appendChild(document.createTextNode(' · ')); box.appendChild(no);
    box.hidden = false;
    yes.addEventListener('click', function () { ls('dc_consent', 'yes'); box.hidden = true; });
    no.addEventListener('click', function () { ls('dc_consent', 'no'); forgetIdentity(); box.hidden = true; });
  }
  function setupArm() {
    var forced = qs.get('arm');
    if (forced === 'game' || forced === 'list') { state.arm = forced; state.forced = true; return false; }
    var a = ls('dc_arm');
    if (a === 'game' || a === 'list') { state.arm = a; return false; }
    var b = new Uint8Array(1); (window.crypto || window.msCrypto).getRandomValues(b);
    state.arm = (b[0] & 1) ? 'game' : 'list'; ls('dc_arm', state.arm);
    return true;
  }

  /* ---- events ---- */
  function post(path, body) {
    body.visitor_id = state.vid; body.arm = state.arm; body.persistent = state.persistent; body.forced_arm = state.forced; body.test = state.test;
    body.brief_id = state.brief ? state.brief.id : null; if (V11KEY) body.v11 = V11KEY;
    try { return fetch(DC.api + path, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'text/plain' }, keepalive: true, credentials: 'omit', mode: 'cors' }); } catch (e) { return Promise.reject(e); }
  }
  function track(name, data) { var p = post('/event', { event: name, data: data || {} }); if (p && p.catch) p.catch(function () { }); }
  function interacted() { if (state.interacted) return; state.interacted = true; track('first_interaction'); }

  /* ---- brief ---- */
  function renderBrief() {
    var b = state.brief;
    $('dc-brief-title').textContent = b.title;
    $('dc-brief-line').textContent = b.line;
    var chips = $('dc-brief-chips'); chips.textContent = '';
    [fmt(STR.cap, { cap: m(b.budget_cents) })].concat(b.requirements.map(function (r) { return STR.req[r]; })).concat([STR.pal[b.palette]]).forEach(function (t) { chips.appendChild(el('li', { text: t })); });
  }

  /* ---- game arm ---- */
  function slotLabel(s) { return DC.slots[s].label; }
  function renderStage() {
    SLOT_ORDER.forEach(function (s) {
      var btn = $('dc-slot-' + s), p = state.picks[s], img = btn.querySelector('img');
      btn.setAttribute('aria-pressed', state.slot === s ? 'true' : 'false');
      if (p) {
        var wPct = p.h * p.w / p.ht;              /* display width in % of stage width; p.h = height in % of stage width */
        btn.style.width = wPct + '%'; btn.style.marginLeft = (-wPct / 2) + '%';
        btn.style.aspectRatio = p.w + ' / ' + p.ht;
        if (!img) { img = el('img', { alt: '', decoding: 'async', crossorigin: 'anonymous' }); btn.appendChild(img); }
        img.src = p.asset_url; img.alt = p.live.title;
        btn.classList.add('is-filled');
        btn.setAttribute('aria-label', fmt(STR.slotFilled, { slot: slotLabel(s), name: p.live.title }));
      } else {
        btn.setAttribute('aria-label', fmt(STR.slotEmpty, { slot: slotLabel(s) }));
      }
    });
    var n = SLOT_ORDER.filter(function (s) { return state.picks[s]; }).length;
    var total = SLOT_ORDER.reduce(function (t, s) { return t + (state.picks[s] ? state.picks[s].price : 0); }, 0);
    $('dc-total').textContent = n ? fmt(STR.total, { total: m(total), cap: m(state.brief.budget_cents) }) : fmt(STR.totalEmpty, { cap: m(state.brief.budget_cents) });
    var cb = $('dc-check'); cb.disabled = n < 3; $('dc-check-hint').style.visibility = n === 3 ? 'hidden' : 'visible';
  }
  function renderTray() {
    var s = state.slot, list = $('dc-tray-list');
    SLOT_ORDER.forEach(function (x) { var t = $('dc-tab-' + x); t.setAttribute('aria-selected', x === s ? 'true' : 'false'); t.tabIndex = x === s ? 0 : -1; });
    list.setAttribute('aria-label', fmt(STR.trayFor, { slot: slotLabel(s) }));
    list.textContent = '';
    bySlot(s).forEach(function (p, i) {
      var picked = state.picks[s] && state.picks[s].key === p.key;
      var card = el('button', { type: 'button', cls: 'dc-card' + (picked ? ' is-picked' : ''), 'aria-pressed': picked ? 'true' : 'false', 'data-key': p.key }, [
        el('span', { cls: 'dc-card-img' }, [el('img', { src: p.asset_url, alt: '', width: p.w, height: p.ht, loading: i < 3 ? 'eager' : 'lazy', decoding: 'async', crossorigin: 'anonymous' })]),
        el('span', { cls: 'dc-card-name', text: p.live.title }),
        el('span', { cls: 'dc-card-var', text: p.variant_label || ' ' }),
        el('span', { cls: 'dc-card-price', text: p.live.price_text }),
        el('span', { cls: 'dc-card-meta', text: p.live.days_text }),
        el('span', { cls: 'dc-card-meta', text: sizeText(p, false) }),
        factsText(p) ? el('span', { cls: 'dc-card-meta', text: factsText(p) }) : null
      ]);
      card.addEventListener('click', function () { place(p); });
      list.appendChild(card);
    });
    list.scrollLeft = 0;
  }
  function place(p) {
    interacted();
    state.picks[p.slot] = p;
    var next = SLOT_ORDER.filter(function (s) { return !state.picks[s]; })[0];
    if (next) state.slot = next;
    hideResult();
    renderStage(); renderTray();
  }
  function reducedMotion() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  /* on a phone the tray sits below the fold: after a tap on a spot, bring the tabs and the tray into view (the corner stays visible above) */
  function showTray() {
    var a = $('dc-tabs'), b = $('dc-tray-list'); if (!a || !b || !a.getBoundingClientRect) return;
    var top = a.getBoundingClientRect().top, bottom = b.getBoundingClientRect().bottom, vh = window.innerHeight || document.documentElement.clientHeight;
    if (top >= 0 && bottom <= vh) return;
    var by = bottom - top <= vh - 20 ? bottom - vh + 12 : top - 8;
    try { window.scrollBy({ top: by, left: 0, behavior: reducedMotion() ? 'auto' : 'smooth' }); } catch (e) { window.scrollBy(0, by); }
  }
  function hideResult() { if (!$('dc-result').hidden) { $('dc-result').hidden = true; $('dc-after').hidden = true; } }
  function star(on) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('class', 'dc-star' + (on ? ' is-on' : '')); s.setAttribute('role', 'img'); s.setAttribute('aria-label', on ? STR.starOn : STR.starOff);
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path'); path.setAttribute('d', 'M12 2.6l2.9 6 6.5.9-4.7 4.6 1.1 6.5L12 17.5l-5.8 3.1 1.1-6.5L2.6 9.5l6.5-.9z'); s.appendChild(path); return s;
  }
  function runCheck() {
    interacted();
    var r = scoreCorner(state.brief, state.picks, DC.currency, DC.money_format);
    state.last = r; state.checks++;
    $('dc-result-title').textContent = fmt(STR.resultTitle, { n: r.stars });
    var rows = $('dc-result-rows'); rows.textContent = '';
    [[STR.rowBudget, r.budget], [STR.rowBrief, r.brief], [STR.rowPalette, r.palette]].forEach(function (x) {
      rows.appendChild(el('li', { cls: 'dc-row' }, [star(x[1].ok), el('div', {}, [el('strong', { text: x[0] }), el('p', { text: x[1].text })])]));
    });
    $('dc-result').hidden = false; $('dc-after').hidden = false;
    $('dc-result-title').focus();
    var keys = SLOT_ORDER.map(function (s) { return state.picks[s].key; });
    track('check', { stars: r.stars, n: state.checks });
    var p = post('/play', { piece_keys: keys, stars: r.stars, total_cents: r.total, currency: DC.currency, detail: { budget: r.budget.ok, brief: r.brief.ok, palette: r.palette.ok } }); if (p && p.catch) p.catch(function () { });
    closePanels();
  }

  /* ---- product rows (both arms) ---- */
  function productRow(p) {
    var btn = el('button', { type: 'button', cls: 'dc-btn dc-btn-primary dc-atc', text: STR.add });
    var msg = el('p', { cls: 'dc-row-msg', role: 'status', 'aria-live': 'polite' });
    btn.addEventListener('click', function () { toggleCart(p, btn, msg); });
    return el('li', { cls: 'dc-prod' }, [
      el('a', { href: p.live.url, cls: 'dc-prod-img' }, [el('img', { src: p.live.img, alt: p.live.title, width: 240, height: 240, loading: 'lazy', decoding: 'async' })]),
      el('div', { cls: 'dc-prod-body' }, [
        el('h3', {}, [el('a', { href: p.live.url, text: p.live.title })]),
        p.variant_label ? el('p', { cls: 'dc-prod-var', text: p.variant_label }) : null,
        el('p', { cls: 'dc-prod-price', text: p.live.price_text }),
        el('p', { cls: 'dc-prod-meta', text: STR.delivery + ': ' + p.live.lane }),
        el('p', { cls: 'dc-prod-meta', text: cap1(sizeText(p, true)) }),
        factsText(p) ? el('p', { cls: 'dc-prod-meta', text: cap1(factsText(p)) }) : null,
        btn, msg
      ])
    ]);
  }
  function toggleCart(p, btn, msg) {
    interacted();
    msg.textContent = '';
    if (state.inCart[p.key]) {
      btn.disabled = true; btn.textContent = STR.removing;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: state.inCart[p.key], quantity: 0 }) })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () { delete state.inCart[p.key]; btn.textContent = STR.add; btn.classList.remove('is-in'); btn.disabled = false; track('remove_from_cart', { piece: p.key }); })
        .catch(function () { btn.textContent = STR.inCart; btn.disabled = false; msg.textContent = STR.cartErr; });
      return;
    }
    btn.disabled = true; btn.textContent = STR.adding;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: p.live.variant_id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (j) {
        var item = j.items && j.items[0]; state.inCart[p.key] = item ? item.key : String(p.live.variant_id);
        btn.textContent = STR.inCart; btn.classList.add('is-in'); btn.disabled = false;
        msg.textContent = ''; msg.appendChild(el('a', { href: '/cart', text: STR.viewCart }));
        track('add_to_cart', { piece: p.key, price: p.price, stars: state.last ? state.last.stars : -1 });
      })
      .catch(function () { btn.textContent = STR.add; btn.disabled = false; msg.textContent = STR.cartErr; });
  }

  /* ---- panels ---- */
  function closePanels() { ['dc-see', 'dc-wait', 'dc-share', 'dc-lead', 'dc-request'].forEach(function (id) { $(id).hidden = true; }); }
  function openPanel(id) { closePanels(); var p = $(id); p.hidden = false; var h = p.querySelector('h2'); if (h) h.focus(); if (p.scrollIntoView) p.scrollIntoView({ block: 'nearest', behavior: reducedMotion() ? 'auto' : 'smooth' }); }
  function openSee() {
    var ul = $('dc-see-list'); ul.textContent = '';
    SLOT_ORDER.forEach(function (s) { if (state.picks[s]) ul.appendChild(productRow(state.picks[s])); });
    openPanel('dc-see'); track('see_pieces', { stars: state.last ? state.last.stars : -1 });
  }
  function openWait() { openPanel('dc-wait'); track('waitlist_open'); }
  function setupWait() {
    var form = $('dc-wait-form'), msg = $('dc-wait-msg');
    form.addEventListener('submit', function (ev) {
      ev.preventDefault(); interacted();
      var email = $('dc-wait-email').value.trim(), ok = $('dc-wait-consent').checked;
      if (!/^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/.test(email)) { msg.textContent = STR.waitErrEmail; $('dc-wait-email').focus(); return; }
      if (!ok) { msg.textContent = STR.waitErrConsent; $('dc-wait-consent').focus(); return; }
      var b = $('dc-wait-submit'); b.disabled = true; b.textContent = STR.waitSending; msg.textContent = '';
      post('/waitlist', { email: email, consent: true, consent_text: STR.waitConsent, piece_key: null })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || !j.ok) throw 0; return j; }); })
        .then(function (j) { form.hidden = true; msg.textContent = fmt(STR.waitDone, { email: email }); msg.focus(); track('waitlist'); })
        .catch(function () { b.disabled = false; b.textContent = STR.waitSubmit; msg.textContent = STR.waitErr; });
    });
  }

  /* ---- v1.1 · shared form helpers ---- */
  var MAIL_RE = /^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/;
  function sendForm(path, body, btn, label, msg, okText, form, evName) {
    btn.disabled = true; btn.textContent = STR.waitSending; msg.textContent = '';
    post(path, body)
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || !j.ok) throw (j && j.error) || 0; return j; }); })
      .then(function (j) { form.hidden = true; msg.textContent = typeof okText === 'function' ? okText(j) : okText; msg.focus(); track(evName); })
      .catch(function (why) { btn.disabled = false; btn.textContent = label; msg.textContent = why === 'full' ? STR.reqFull : STR.formErr; });
  }

  /* ---- v1.1 · lead at the reward (game arm, after the check; replaces the v1 waitlist action when features.lead is on) ---- */
  function openLead() { openPanel('dc-lead'); track('lead_open', { stars: state.last ? state.last.stars : -1 }); }
  function setupLead() {
    var form = $('dc-lead-form'), msg = $('dc-lead-msg'); if (!form) return;
    form.addEventListener('submit', function (ev) {
      ev.preventDefault(); interacted();
      var email = $('dc-lead-email').value.trim();
      if (!MAIL_RE.test(email)) { msg.textContent = STR.waitErrEmail; $('dc-lead-email').focus(); return; }
      if (!$('dc-lead-consent').checked) { msg.textContent = STR.waitErrConsent; $('dc-lead-consent').focus(); return; }
      sendForm('/lead', { email: email, consent: true, consent_text: STR.leadConsent, taste_result: state.taste, website: $('dc-lead-hp').value },
        $('dc-lead-submit'), STR.leadSubmit, msg, function (j) { return fmt(j.mail === 'later' ? STR.leadLater : STR.leadDone, { email: email }); }, form, 'lead_submit');
    });
  }
  /* the link in the confirmation mail opens this page with ?confirm=<token>; the page hands the token to the server once and removes it from the address bar */
  function confirmLead() {
    var tok = qs.get('confirm'); if (!tok || !/^[A-Za-z0-9_-]{20,64}$/.test(tok)) return;
    var box = $('dc-banner'); if (!box) return;
    try { qs.delete('confirm'); var left = qs.toString(); history.replaceState(null, '', location.pathname + (left ? '?' + left : '')); } catch (e) { }
    post('/lead/confirm', { token: tok })
      .then(function (r) { return r.json().then(function (j) { return { s: r.status, j: j }; }); })
      .then(function (x) { box.textContent = x.j && x.j.ok ? fmt(STR.confirmOk, { n: x.j.grant_previews }) : (x.s === 404 ? STR.confirmBad : STR.confirmErr); box.hidden = false; box.focus(); })
      .catch(function () { box.textContent = STR.confirmErr; box.hidden = false; });
  }

  /* ---- v1.1 · request lane (both arms). The link is kept as text; nothing on this page opens or fetches it. ---- */
  function openRequest() { interacted(); openPanel('dc-request'); track('request_open'); }
  function setupRequest() {
    var form = $('dc-req-form'), msg = $('dc-req-msg'), ta = $('dc-req-text'), left = $('dc-req-left'); if (!form) return;
    function count() { left.textContent = fmt(STR.reqLeft, { n: Math.max(0, 300 - ta.value.length) }); }
    ta.addEventListener('input', count); count();
    form.addEventListener('submit', function (ev) {
      ev.preventDefault(); interacted();
      var text = ta.value.replace(/\s+/g, ' ').trim(), link = $('dc-req-link').value.trim(), email = $('dc-req-email').value.trim();
      if (text.length < 3 || text.length > 300) { msg.textContent = STR.reqErrText; ta.focus(); return; }
      if (link && !/^https?:\/\/[^\s<>"']{4,}$/i.test(link) || link.length > 500) { msg.textContent = STR.reqErrLink; $('dc-req-link').focus(); return; }
      if (!MAIL_RE.test(email)) { msg.textContent = STR.waitErrEmail; $('dc-req-email').focus(); return; }
      if (!$('dc-req-consent').checked) { msg.textContent = STR.waitErrConsent; $('dc-req-consent').focus(); return; }
      sendForm('/request', { text: text, link: link || null, email: email, consent: true, consent_text: STR.reqConsent, taste_result: state.taste, website: $('dc-req-hp').value },
        $('dc-req-submit'), STR.reqSubmit, msg, fmt(STR.reqDone, { email: email }), form, 'request_submit');
    });
  }

  /* ---- v1.1 · taste start (game arm only, first screen; "Skip" always there; nothing typed, no sign-in) ---- */
  var tasteSeen = false;
  function liveTiles() { var live = {}; pieces.forEach(function (p) { live[p.key] = 1; }); return ((DC.taste && DC.taste.tiles) || []).filter(function (t) { return t.pieces.every(function (k) { return live[k]; }); }); }
  function storedTaste() { try { var j = JSON.parse(ls('dc_taste') || 'null'); return j && STR.tasteNames[j.k] ? j : null; } catch (e) { return null; } }
  function endTaste() {
    $('dc-taste').hidden = true; $('dc-brief').hidden = false; $('dc-game').hidden = false;
    renderStage(); renderTray();
    var h = $('dc-h1'); if (h && h.focus) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); } try { window.scrollTo(0, 0); } catch (e) { }
  }
  function showTaste() {
    var tiles = liveTiles(), need = (DC.taste && DC.taste.pick) || 3; if (tasteSeen || tiles.length < 4) return;   /* every piece in a tile must still be on sale */
    tasteSeen = true;
    var picked = [], grid = $('dc-taste-grid'), cnt = $('dc-taste-count'); grid.textContent = '';
    $('dc-brief').hidden = true; $('dc-game').hidden = true; $('dc-taste-pick').hidden = false; $('dc-taste-result').hidden = true; $('dc-taste').hidden = false;
    function upd() { cnt.textContent = fmt(STR.tasteCount, { n: picked.length }); }
    tiles.forEach(function (t, i) {
      var b = el('button', { type: 'button', cls: 'dc-tile', 'aria-pressed': 'false' }, [el('img', { src: t.asset_url, alt: t.alt, width: DC.taste.w, height: DC.taste.h, loading: i < 4 ? 'eager' : 'lazy', decoding: 'async' })]);
      b.addEventListener('click', function () {
        var at = picked.indexOf(t);
        if (at >= 0) { picked.splice(at, 1); b.setAttribute('aria-pressed', 'false'); upd(); return; }
        if (picked.length >= need) return;
        picked.push(t); b.setAttribute('aria-pressed', 'true'); upd();
        if (picked.length === need) {
          var r = tasteResult(picked), ids = picked.map(function (x) { return x.id; });
          state.taste = r.kind; state.tasteTiles = ids; if (SLOT_ORDER.indexOf(r.slot) >= 0) state.slot = r.slot;
          if (state.persistent) ls('dc_taste', JSON.stringify({ k: r.kind, s: state.slot, t: ids }));
          track('taste', { tiles: ids.join(','), result: r.kind, slot: state.slot });
          $('dc-taste-name').textContent = STR.tasteNames[r.kind]; $('dc-taste-line').textContent = STR.tasteLines[r.kind];
          $('dc-taste-pick').hidden = true; $('dc-taste-result').hidden = false; $('dc-taste-name').focus();
        }
      });
      grid.appendChild(b);
    });
    upd();
  }
  function setupTaste() {
    if (!$('dc-taste')) return;
    $('dc-taste-skip').addEventListener('click', function () { track('taste', { tiles: '', result: 'skip' }); endTaste(); });
    $('dc-taste-play').addEventListener('click', endTaste);
    var st = state.persistent ? storedTaste() : null;
    if (st) { state.taste = st.k; state.tasteTiles = st.t || []; if (SLOT_ORDER.indexOf(st.s) >= 0) state.slot = st.s; tasteSeen = true; renderStage(); renderTray(); }
  }

  /* ---- v1.1 · flags ---- */
  function applyFeatures() {
    var game = state.arm === 'game', w = document.querySelector('[data-dc-wait]');
    if (w) w.textContent = FEAT.lead && game ? STR.leadBtn : STR.tryBtn;
    if ($('dc-req-btn')) $('dc-req-btn').hidden = !FEAT.request;
    if ($('dc-req-tray')) $('dc-req-tray').hidden = !(FEAT.request && game);
    if (!FEAT.request && $('dc-request')) $('dc-request').hidden = true;
    if (!FEAT.lead && $('dc-lead')) $('dc-lead').hidden = true;
    if (FEAT.taste && game && !state.interacted && !state.taste && $('dc-rest').hidden) showTaste();
  }
  function serverFeatures(f) {
    if (V11KEY) return;                     /* the tester's flags come from POST /tester */
    if (f) {
      FEAT = { taste: f.taste === true, lead: f.lead === true, request: f.request === true };
      ls('dc_feat', FEAT.taste || FEAT.lead || FEAT.request ? JSON.stringify(FEAT) : null);   /* with every flag off nothing extra is stored */
    }
    flagsReady();
  }
  /* fix 22 Sep (review M8): until the flags are known the game arm shows a neutral skeleton instead of the game, so the game
     never flashes before the taste screen. Cap 1.5 s: then the game comes, and this load does not swap to the taste screen any more. */
  var flagsKnown = true, holdTimer = null;
  function holdGame() {
    flagsKnown = false; $('dc-game').hidden = true; if ($('dc-skel')) $('dc-skel').hidden = false;
    holdTimer = setTimeout(function () { tasteSeen = true; flagsReady(); }, 1500);
  }
  function flagsReady() {
    var first = !flagsKnown; flagsKnown = true; if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
    applyFeatures();                        /* may open the taste screen (which keeps the game hidden) */
    if (first) { if ($('dc-skel')) $('dc-skel').hidden = true; if (state.arm === 'game' && $('dc-rest').hidden && $('dc-taste').hidden) $('dc-game').hidden = false; }
  }
  function askTester() {
    post('/tester', {}).then(function (r) { return r.json(); }).then(function (j) {
      if (j && j.tester === true) { V11 = true; FEAT = { taste: true, lead: true, request: true }; }
      flagsReady();
    }).catch(function () { flagsReady(); });
  }

  /* ---- share card ---- */
  function fitText(ctx, text, x, y, maxW, px, font) { do { ctx.font = font.replace('{px}', px); px -= 2; } while (ctx.measureText(text).width > maxW && px > 16); ctx.fillText(text, x, y); }
  function loadImg(src) { return new Promise(function (res, rej) { var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { res(i); }; i.onerror = rej; i.src = src; }); }
  function shareUrl() { return location.origin + '/pages/magic-mirror-home?utm_source=magic_mirror&utm_medium=social&utm_campaign=share'; }
  function openShare() {
    openPanel('dc-share'); track('share', { stars: state.last ? state.last.stars : -1 });
    var tasteName = FEAT.taste && state.taste ? STR.tasteNames[state.taste] : null;
    var W = DC.room.w, H = DC.room.h, band = tasteName ? 234 : 190, cv = $('dc-share-canvas'); cv.width = W; cv.height = H + band;
    var ctx = cv.getContext('2d'), order = SLOT_ORDER.map(function (s) { return state.picks[s]; });
    Promise.all([loadImg(DC.room.url)].concat(order.map(function (p) { return loadImg(p.asset_url); }))).then(function (im) {
      ctx.fillStyle = '#F8F2EF'; ctx.fillRect(0, 0, W, H + band); ctx.drawImage(im[0], 0, 0, W, H);
      order.forEach(function (p, i) {
        var a = DC.slots[p.slot], h = p.h / 100 * W, w = h * p.w / p.ht, x = a.x / 100 * W - w / 2, y = a.y / 100 * H - h;
        ctx.save(); ctx.shadowColor = 'rgba(40,30,20,.35)'; ctx.shadowBlur = 18; ctx.shadowOffsetY = 8; ctx.drawImage(im[i + 1], x, y, w, h); ctx.restore();
      });
      ctx.fillStyle = '#5C212B'; ctx.font = '600 46px "Playfair Display", Georgia, serif'; fitText(ctx, STR.brand + ' · ' + state.brief.title, 48, H + 66, W - 96, 46, '600 {px}px "Playfair Display", Georgia, serif');
      ctx.fillStyle = '#485154'; ctx.font = '30px Inter, Arial, sans-serif';
      var stars = ''; for (var k = 0; k < 3; k++) stars += k < state.last.stars ? '★' : '☆';
      fitText(ctx, stars + '  ' + m(state.last.total) + ' · cap ' + m(state.brief.budget_cents) + '  ·  ' + STR.shareUrlText, 48, H + 116, W - 96, 30, '{px}px Inter, Arial, sans-serif');
      if (tasteName) { ctx.font = '30px Inter, Arial, sans-serif'; ctx.fillText(fmt(STR.tasteShare, { name: tasteName }), 48, H + 162); }
      ctx.font = '24px Inter, Arial, sans-serif'; ctx.fillText(STR.shareFoot, 48, H + (tasteName ? 204 : 160));
      cv.toBlob(function (blob) {
        if (!blob) { $('dc-share-msg').textContent = STR.shareErr; return; }
        var file = new File([blob], STR.shareFile, { type: 'image/png' }), url = URL.createObjectURL(blob);
        var save = $('dc-share-save'); save.href = url; save.hidden = false;
        var nat = $('dc-share-native');
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          nat.hidden = false;
          nat.onclick = function () { navigator.share({ files: [file], text: fmt(STR.shareText, { brief: state.brief.title, n: state.last.stars }), url: shareUrl() }).catch(function () { }); };
        }
        cv.setAttribute('data-ready', '1');
      }, 'image/png');
    }).catch(function () { $('dc-share-msg').textContent = STR.shareErr; });
  }

  /* ---- list arm ---- */
  function renderList() {
    var box = $('dc-list-groups'); box.textContent = '';
    SLOT_ORDER.forEach(function (s) {
      var ul = el('ul', { cls: 'dc-prods' }); bySlot(s).forEach(function (p) { ul.appendChild(productRow(p)); });
      box.appendChild(el('section', {}, [el('h2', { text: STR.listSlotTitle[s] }), ul]));
    });
  }

  function rest(text) {
    $('dc-game').hidden = true; $('dc-list').hidden = true; $('dc-after').hidden = true; $('dc-brief').hidden = true;
    ['dc-taste', 'dc-request', 'dc-lead', 'dc-skel'].forEach(function (id) { if ($(id)) $(id).hidden = true; });
    flagsKnown = true; if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
    var r = $('dc-rest'); r.hidden = false; $('dc-rest-text').textContent = text;
  }

  /* ---- start ---- */
  function start() {
    var fresh = setupArm(); setupIdentity();
    var idx = briefIndex(DC.week_start, amsToday(), DC.briefs.length);
    state.brief = DC.briefs[idx];
    var enough = SLOT_ORDER.every(function (s) { return bySlot(s).length >= 2; });
    if (!enough) { rest(STR.fewPieces); return; }
    document.body.setAttribute('data-arm', state.arm);
    $('dc-h1').textContent = state.arm === 'game' ? STR.h1Game : STR.h1List;
    $('dc-intro').textContent = state.arm === 'game' ? STR.introGame : STR.introList;
    renderBrief();
    if (state.arm === 'game') {
      $('dc-game').hidden = false;
      SLOT_ORDER.forEach(function (s) {
        $('dc-slot-' + s).addEventListener('click', function () { interacted(); state.slot = s; renderStage(); renderTray(); $('dc-tab-' + s).focus({ preventScroll: true }); showTray(); });
        $('dc-tab-' + s).addEventListener('click', function () { interacted(); state.slot = s; renderStage(); renderTray(); });
      });
      $('dc-tabs').addEventListener('keydown', function (ev) {
        var i = SLOT_ORDER.indexOf(state.slot);
        if (ev.key === 'ArrowRight' || ev.key === 'ArrowLeft') { i = (i + (ev.key === 'ArrowRight' ? 1 : 2)) % 3; state.slot = SLOT_ORDER[i]; renderStage(); renderTray(); $('dc-tab-' + state.slot).focus(); ev.preventDefault(); }
      });
      $('dc-check').addEventListener('click', runCheck);
      $('dc-see-btn').addEventListener('click', openSee);
      $('dc-share-btn').addEventListener('click', openShare);
      $('dc-share-copy').addEventListener('click', function () { var t = shareUrl(); (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function () { $('dc-share-msg').textContent = STR.shareCopied; }).catch(function () { $('dc-share-msg').textContent = t; }); });
      renderStage(); renderTray();
    } else {
      $('dc-list').hidden = false; $('dc-after').hidden = false; $('dc-after-game').hidden = true; $('dc-see-btn').hidden = true; $('dc-brief').hidden = true;
      renderList();
    }
    document.querySelectorAll('[data-dc-wait]').forEach(function (b) { b.addEventListener('click', function () { if (FEAT.lead && state.arm === 'game') openLead(); else openWait(); }); });
    setupWait();
    /* v1.1 */
    var cachedFeat = null;
    if (!V11KEY) { try { var cf = JSON.parse(ls('dc_feat') || 'null'); if (cf) { cachedFeat = cf; FEAT = { taste: cf.taste === true, lead: cf.lead === true, request: cf.request === true }; } } catch (e) { } }
    setupLead(); setupRequest();
    ['dc-req-btn', 'dc-req-tray'].forEach(function (id) { if ($(id)) $(id).addEventListener('click', openRequest); });
    if (state.arm === 'game') setupTaste();
    /* flags not known yet (first visit, or the tester's key is still being checked) and no taste result kept: hold the game */
    if (state.arm === 'game' && !state.taste && (V11KEY || !cachedFeat)) holdGame();
    applyFeatures();
    if (V11KEY) askTester();
    confirmLead();

    var today = amsToday(), first = state.persistent ? ls('dc_first') : null, last = state.persistent ? ls('dc_last') : null;
    track('visit', { ref: document.referrer ? 'ext' : 'direct', utm: (qs.get('utm_source') || '').slice(0, 40), returning: !!(first && first < today) });
    if (fresh) track('arm');
    if (state.persistent) {
      if (!first) ls('dc_first', today);
      if (last && last < today) track('return_visit', { days_since_first: Math.round((Date.parse(today) - Date.parse(first || today)) / 86400000) });
      ls('dc_last', today);
    }

    /* the server may switch the game off, correct the day's brief, or drop a piece that failed the nightly validity run */
    var ctl = window.AbortController ? new AbortController() : null, timer = setTimeout(function () { if (ctl) ctl.abort(); }, 2500);
    fetch(DC.api + '/today', { signal: ctl ? ctl.signal : undefined, credentials: 'omit', mode: 'cors' }).then(function (r) { return r.json(); }).then(function (j) {
      clearTimeout(timer);
      if (j.enabled === false) { rest(STR.resting); return; }
      serverFeatures(j.features);
      if (Array.isArray(j.valid_keys)) {
        var before = pieces.length; pieces = pieces.filter(function (p) { return j.valid_keys.indexOf(p.key) >= 0; });
        if (pieces.length !== before && !state.interacted) { if (!SLOT_ORDER.every(function (s) { return bySlot(s).length >= 2; })) { rest(STR.fewPieces); return; } if (state.arm === 'game') renderTray(); else renderList(); }
      }
      if (j.brief && j.brief.id !== state.brief.id && !state.interacted) { var nb = DC.briefs.filter(function (b) { return b.id === j.brief.id; })[0]; if (nb) { state.brief = nb; renderBrief(); if (state.arm === 'game') renderStage(); } }
    }).catch(function () { clearTimeout(timer); if (!V11KEY) flagsReady(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})(typeof window !== 'undefined' ? window : this);
